import { useLottie } from 'lottie-react';
import React from 'react';
import noDataFoundAnim from '../../../assets/animations/noDataFound.json';

type props = { height?: number };
export default function DataNotFound({ height = 300 }: props) {
	return (
		<div className="flex flex-col mx-auto my-auto text-center align-middle overflow-clip h-full ">
			<div className="mx-auto my-auto self-center">
				<div className="min-h-16">
					<DataNotFoundAnimation height={height} />
				</div>
				<h3 className="lg:text-2xl text-xl font-bold dark:text-gray-200 text-gray-700 -mt-8">
					{"Couldn't find the data you're looking for!"}
				</h3>
			</div>
		</div>
	);
}

export function DataNotFoundAnimation({ height = 300 }: props) {
	const options = {
		style: { height: height },
		animationData: noDataFoundAnim,
		loop: true,
		autoplay: true
	};

	const { View } = useLottie(options);

	return View;
}
